export default __webpack_public_path__ + "static/media/burger-icon.d9698a56.svg";